import { createAction, props } from '@ngrx/store';

export const NOTE_CHANGES = createAction(
  '[Notes] Note Changes',
  props<{ payload: { targetType: string; targetId: string; campaignId: string } }>()
);
